import { Pagination, IPaginationRange } from "@gisce/oficina-virtual-components";
import { useTranslation } from "react-i18next";
import { MenuItem, Select, SelectChangeEvent, Stack } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";
import { ContractDisplayTypes } from "../../types/contracts";
import { useContracts } from "../../hooks/useContracts";

// TODO: This component should bepart of an abstraction for a generic table

interface IContractsPagination {
  currentPage: number;
  itemsPerPage: number;
  itemsTotal: number;
  setCurrentPage: (newPage: number) => void;
  setItemsPerPage: (newItemsPerPage: number) => void;
}

const ContractsPagination: FC<IContractsPagination> = ({
  currentPage,
  itemsPerPage,
  itemsTotal,
  setCurrentPage,
  setItemsPerPage
}) => {
  const { t } = useTranslation();
  const Settings = useSettingsContext();

  /**
   * Handles the page change event for the Pagination component.
   *
   * @param {IPaginationRange} range - The range of items to display.
   * @param {number} page - The page number to navigate to.
   * @param {boolean} outOfRange - Whether the target page is outside the valid range.
   *
   * @returns {void}
   */
  const handleChangePage = (
    range: IPaginationRange, 
    newPage: number, 
    outOfRange: boolean
  ) => {
    // Prevent unnecessary API calls for out-of-range pages
    if(!outOfRange) {
      setCurrentPage(newPage)
    }
  }

  const handleItemsPerPageChange = (event: SelectChangeEvent) => {
    setItemsPerPage(Number(event.target.value));
  };

  const getPossibleItemsPerPage = () => {
    let possibleItemsPerPage = [5, 10, 25, 50, 100];
    if (Settings?.contracts?.itemsPerPage && !possibleItemsPerPage.includes(Settings.contracts.itemsPerPage)) {
      possibleItemsPerPage.push(Settings.contracts.itemsPerPage);
      possibleItemsPerPage.sort((a, b) => { return a - b; });
    }
    return possibleItemsPerPage;
  }

  return ( itemsTotal > itemsPerPage &&
    <Stack direction="row">
      <Stack flexGrow={1} direction="row" alignItems="center" justifyContent="center">
        <Pagination 
          itemsPerPage={itemsPerPage}
          itemsTotal={itemsTotal}
          onPageChange={handleChangePage}
          currentPage={currentPage}
          color="primary"
        />
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="center" gap={2}>
        {t("common:text.pagination_items_per_page")}
        <Select
          variant="standard"
          value={itemsPerPage.toString()}
          label="Items"
          onChange={handleItemsPerPageChange}
        >
          {getPossibleItemsPerPage().map((itemsPerPage, idx) => {
            return <MenuItem value={Number(itemsPerPage)} key={idx}>
              {Number(itemsPerPage)}
            </MenuItem>
          })}
        </Select>
      </Stack>
    </Stack>
  )
}

export default ContractsPagination;